import React from "react";
import { Carousel, Card, Container } from "react-bootstrap";
import foto1 from "../assets/images/fotossanus1.jpg";
import foto2 from "../assets/images/fotossanus2.jpg";
import foto3 from "../assets/images/fotossanus3.jpg";
import foto4 from "../assets/images/fotossanus4.jpg";

export default function HeroCarousel() {
  const photos = [
    {
      src: foto1,
      alt: "Bienvenidos a Sanus Esthetic, tu espacio de transformación",
    },
    {
      src: foto2,
      alt: "Tecnología de punta al servicio de tu belleza y salud",
    },
    { src: foto3, alt: "Instalaciones modernas pensadas para tu bienestar" },
    { src: foto4, alt: "Atención cómoda y especializada para cada cliente" },
  ];

  return (
    <Container className="my-5" id="herocarousel">
      <Carousel fade>
        {photos.map((item, idx) => (
          <Carousel.Item className="fade-in" key={idx}>
            <Card
              className="mx-auto shadow rounded"
              style={{ width: "80%", overflow: "hidden" }}
            >
              <Card.Img
                variant="top"
                src={item.src}
                alt={item.alt}
                style={{
                  height: "350px",
                  objectFit: "cover",
                  transition: "transform 0.5s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
              <Card.Body className="text-center">
                <Card.Title style={{ color: "#056d7a" }}>{item.alt}</Card.Title>
              </Card.Body>
            </Card>
          </Carousel.Item>
        ))}
      </Carousel>
    </Container>
  );
}
